import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import PropTypes from "prop-types";
import ScGridTable from "@/components/display/table/gridTableCore";
import moment from "moment";
import { connect } from "react-redux";
import { stubEventMonitoringDetailNew } from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";

@connect((state) => state)
class MonitoringDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.initMsg();
    this.state = {
      formConfig: null,
    };
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 页面加载前调用方法
   */
  componentWillMount() {
    // 获取新开页参数
    this.query = {};
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["stubId"] = window.LayoutTab.tabParam.stubId
        ? window.LayoutTab.tabParam.stubId
        : "";
      this.query["startTime"] = window.LayoutTab.tabParam.createTime
        ? window.LayoutTab.tabParam.createTime
        : "";
      this.query["endTime"] = window.LayoutTab.tabParam.modifyTime
        ? window.LayoutTab.tabParam.modifyTime
        : "";
      this.query["eventCfgId"] = window.LayoutTab.tabParam.eventCfgId
        ? window.LayoutTab.tabParam.eventCfgId
        : "";
      this.query["subjectSerial"] = window.LayoutTab.tabParam.subjectSerial
        ? window.LayoutTab.tabParam.subjectSerial
        : "";
    }

    this.init();
  }

  /**
   * 页面加载完成调用方法
   */
  componentDidMount() {
    this.setState({
      stubId: this.query.stubId,
    });
  }

  /**
   * 获取原页面传递参数
   */
  initMsg() {
    this.query = {};
  }
  /**
   * 初始化表单
   */

  setFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeDateTime",
          placeholder: ["开始时间", "结束时间"],
          width: "300px",
          param: {
            name: "date",
            type: "array",
          },
          defaultValue: [moment(this.query.startTime), moment(this.query.endTime)],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          labelName: "起止时间:",
          required: true,
          allowClear: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              message:
                "详情页展示的时间为设备产生数据的时间，而告警事件的时间是平台接收到设备数据的时间。该页面默认查询的开始时间为告警事件生成时间，所以会造成详情数据未查询出来，这时候需要手动筛选查询时间。",
              text: "查询",
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "gird", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: true, // 设置为false不触发加载grid
      context: this,
      tableKey: "eventMonitoringDetail",
    };
    return formConfig;
  };

  /**
   * 初始化表格
   */
  init() {
    this.setState({
      formConfig: this.setFormConfig(),
      tableConfig: {
        tableKey: "eventMonitoringDetail",
        tableColumns: [
          {
            name: "模块编号",
            key: "subjectSerial",
            colType: "textCol",
            align: "center",
          },
          {
            name: "上报时间",
            key: "time",
            colType: "textCol",
            align: "center",
          },
          {
            name: "业务订单号",
            key: "orderId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "详情",
            key: "msg",
            colType: "textCol",
            align: "center",
          },
          {
            name: "操作",
            key: "action",
            fix: "right",
            width: 100,
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: "充电数据",
                handler: (res) => {
                  this.openTab(
                    {
                      keyId: "chargeCourse",
                      orderId: res.orderId,
                    },
                    {
                      key: "chargeCourse",
                      titleText: "充电数据",
                    },
                  );
                },
              },
              {
                type: "href",
                actionName: "模块数据",
                handler: (res) => {
                  this.openTab(
                    {
                      keyId: "powerCourse",
                      orderId: res.orderId,
                    },
                    {
                      key: "powerCourse",
                      titleText: "模块数据",
                    },
                  );
                },
              },
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pageCount: 10,
          stubId: this.query.stubId,
          startTime: this.query.startTime,
          endTime: this.query.endTime,
          eventCfgId: this.query.eventCfgId,
        },
        dataApi: stubEventMonitoringDetailNew,
        autoRefresh: 1, // 设置为true 直接加载grid数据
      },
    });
  }

  /**
   * 新开页方法
   */
  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  /**
   *
   * 更新表格数据方法
   */
  fetchApi = (param) => {
    const newParam = {};
    const date = param.date.split(",");
    // 对开始时间结束时间进行处理
    newParam.startTime = moment(date[0]).format("YYYY.MM.DD HH:mm:ss");
    newParam.endTime = moment(date[1]).format("YYYY.MM.DD HH:mm:ss");

    // 如果正常页面中的表单提交，请执行下面
    return RefreshGrid(this.context.store, "eventMonitoringDetail", newParam);
  }

  render() {
    const Content = (
      <div className='sc-page-content eventMonitoringDetail' style={{ paddingTop: 24 }}>
        <div className='page-tool'>
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className='page-panel'>
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>
      </div>
    );

    return Content;
  }
}

export default MonitoringDetail;



// WEBPACK FOOTER //
// ./src/AntD/pages/exceptionManagement/eventMonitoring/monitoringDetail.js